import { helpdeskRoutes } from '@/Helpdesk/helpdesk.routes';
const helpdesk = {
    routes: helpdeskRoutes
};
export default helpdesk;
